import { apiService } from '../services/apiService';

function isPdfPlan(contentType, fileName) {
  const type = (contentType || '').toLowerCase();
  const name = (fileName || '').toLowerCase();
  return type.includes('pdf') || name.endsWith('.pdf');
}

function loadImageFromUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Impossible de charger l\'image du plan'));
    img.src = url;
  });
}

async function pdfBlobToImage(blob) {
  const pdfjsLib = await import('pdfjs-dist');
  pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

  const data = await blob.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data }).promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 2 });
  const canvas = document.createElement('canvas');
  canvas.width = viewport.width;
  canvas.height = viewport.height;
  const ctx = canvas.getContext('2d');
  await page.render({ canvasContext: ctx, viewport }).promise;
  return loadImageFromUrl(canvas.toDataURL('image/png'));
}

export async function loadPlanImageElement(plan) {
  const { blob, blobUrl, contentType, fileName } = await apiService.fetchPlanFile(plan);

  try {
    if (isPdfPlan(contentType, fileName)) {
      const img = await pdfBlobToImage(blob);
      URL.revokeObjectURL(blobUrl);
      return { img, blobUrl: null, isPdf: true };
    }

    const img = await loadImageFromUrl(blobUrl);
    return { img, blobUrl, isPdf: false };
  } catch (error) {
    URL.revokeObjectURL(blobUrl);
    if (isPdfPlan(contentType, fileName)) {
      throw new Error(
        'Le plan est un PDF : conversion impossible. Réessayez ou importez une image (JPG/PNG).'
      );
    }
    throw error instanceof Error
      ? error
      : new Error('Impossible de charger l\'image du plan');
  }
}
